// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 62.57.0 (Slice B, owner decision (b), 2026-10-30) — the effect of an
 * authority's appraisal result.
 *
 * The pack declares each result option with its bilingual label and ONE effect
 * from this closed set. Whether an appraisal passed, passed subject to
 * supplement, or failed is a property of the activity, not of an instrument
 * (R-46), so the platform branches on the effect and never on an option id or a
 * label.
 */
export const APPRAISAL_EFFECTS = ['passed', 'passed_supplement_required', 'failed'];
/** What a result opens, declared per assessment kind and effect by the pack. */
export const APPRAISAL_FOLLOW_UPS = ['none', 'result_supplement', 'failure_follow_up'];
/**
 * The two result values filings stored before Slice B (AC-B2). Read only: no
 * new write produces them. Each maps to an effect, and to the option of the
 * governing text that declares the same `legacy_outcome`.
 */
export const LEGACY_DOSSIER_OUTCOMES = ['accepted', 'rejected'];
export const LEGACY_OUTCOME_EFFECT = {
    accepted: 'passed',
    rejected: 'failed',
};
/**
 * E12.5 F1 — the statuses from which the authority's result may be recorded:
 * after submission, after resubmission, and after a post-result supplement
 * was submitted (AC-B3's further result). Read by the route and by the page.
 */
export const DOSSIER_RESULT_RECORDABLE_STATUSES = [
    'submitted',
    'resubmitted',
    'result_supplement_submitted',
    // Sprint 62.57.0 (Slice C, D30): a further result after a completion.
    'result_completion_submitted',
];
//# sourceMappingURL=dossier-appraisal.js.map